export const TypesControleReefer = {
    BUSCARCONTAINERREEFER: "BUSCARCONTAINERREEFER",
    NUMEROCONTAINERREEFER: "NUMEROCONTAINERREEFER",
    RESETCONTROLEREEFER: "RESETCONTROLEREEFER",
    LEITURATEMPERATURA: "LEITURATEMPERATURA",
    SETPOINT: "SETPOINT",
    SUPPLY: "SUPPLY",
    RETORNO: "RETORNO",
    UMIDADE: "UMIDADE",
    VENTILACAO: "VENTILACAO",
    AVARIA: "AVARIA",
    SELECTEDPASSAGEMID: "SELECTEDPASSAGEMID",
    UPLOADIMAGEM: "UPLOADIMAGEM"
}

const INITIAL = {
    Containers: [],
    NumeroReefer: '',
    LeituraTemperatura: false,
    SetPointValue: '',
    SupplyValue: '',
    RetornoValue: '',
    UmidadeValue: '',
    VentilacaoValue: '',
    AvariaDescricao: '',
    SelectedPassagemId: 0,
    Imagem: []
}

export default function controleReeferReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesControleReefer.UPLOADIMAGEM:
            return {
                ...state,
                Imagem: action.payload
            };
        case TypesControleReefer.BUSCARCONTAINERREEFER:
            return {
                ...state,
                Containers: action.payload
            };
        case TypesControleReefer.NUMEROCONTAINERREEFER:
            return {
                ...state,
                NumeroReefer: action.payload.NumeroReefer
            };
        case TypesControleReefer.LEITURATEMPERATURA:
            return {
                ...state,
                LeituraTemperatura: action.payload.LeituraTemperatura
            };
        case TypesControleReefer.SETPOINT:
            return {
                ...state,
                SetPointValue: action.payload.SetPointValue
            };
        case TypesControleReefer.SUPPLY:
            return {
                ...state,
                SupplyValue: action.payload.SupplyValue
            };
        case TypesControleReefer.RETORNO:
            return {
                ...state,
                RetornoValue: action.payload.RetornoValue
            };
        case TypesControleReefer.UMIDADE:
            return {
                ...state,
                UmidadeValue: action.payload.UmidadeValue
            };
        case TypesControleReefer.VENTILACAO:
            return {
                ...state,
                VentilacaoValue: action.payload.VentilacaoValue
            };
        case TypesControleReefer.AVARIA:
            return {
                ...state,
                AvariaDescricao: action.payload.AvariaDescricao
            };
        case TypesControleReefer.SELECTEDPASSAGEMID:
            return {
                ...state,
                SelectedPassagemId: action.payload.SelectedPassagemId
            };
        case TypesControleReefer.RESETCONTROLEREEFER:
            return INITIAL;
        default:
            return state;
    }

}
export const ControleReeferActions = {
    loadData,
    findContainerReefer,
    resetControleReeferState,
    updateLeituraTemperatura,
    setPointState,
    setSupplayState,
    setRetornoState,
    setUmidadeState,
    setVentilacaoState,
    setAvariaState,
    setSelectedPassagemId,
    uploadImagem
}

function uploadImagem(imagem) {
    return {
        type: TypesControleReefer.UPLOADIMAGEM,
        payload: imagem
    }
}

function loadData(dados) {
    return {
        type: TypesControleReefer.BUSCARCONTAINERREEFER,
        payload: dados
    }
}

function findContainerReefer(parametroBusca) {

    return {
        type: TypesControleReefer.NUMEROCONTAINERREEFER,
        payload: { NumeroReefer: parametroBusca }
    }
}

function updateLeituraTemperatura(parametro) {

    return {
        type: TypesControleReefer.LEITURATEMPERATURA,
        payload: { LeituraTemperatura: parametro }
    }
}

function setPointState(value) {

    return {
        type: TypesControleReefer.SETPOINT,
        payload: { SetPointValue: value }
    }
}

function setSupplayState(value) {

    return {
        type: TypesControleReefer.SUPPLY,
        payload: { SupplyValue: value }
    }
}

function setRetornoState(value) {

    return {
        type: TypesControleReefer.RETORNO,
        payload: { RetornoValue: value }
    }
}

function setUmidadeState(value) {

    return {
        type: TypesControleReefer.UMIDADE,
        payload: { UmidadeValue: value }
    }
}

function setVentilacaoState(value) {

    return {
        type: TypesControleReefer.VENTILACAO,
        payload: { VentilacaoValue: value }
    }
}

function setAvariaState(value) {

    return {
        type: TypesControleReefer.AVARIA,
        payload: { AvariaDescricao: value }
    }
}

function setSelectedPassagemId(value) {

    return {
        type: TypesControleReefer.SELECTEDPASSAGEMID,
        payload: { SelectedPassagemId: value }
    }
}

function resetControleReeferState() {
    return { type: "RESETCONTROLEREEFER" }
}